/**
 * TrainingType Create Page
 * Page for creating new TrainingType
 */
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Card,
  CardContent,
  Alert,
} from '@mui/material';
import { PageShell } from '../../components';
import { trainingTypeService } from '../../services/trainingTypeService';
import { TrainingTypeFormData } from '../../types/trainingType';
import { TrainingTypeForm } from './components/TrainingTypeForm';

export const TrainingTypeCreatePage: React.FC = () => {
  const navigate = useNavigate();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleSubmit = async (data: TrainingTypeFormData) => {
    try {
      setIsSubmitting(true);
      setError(null);
      await trainingTypeService.create(data);
      navigate('/training-types');
    } catch (err: unknown) {
      const error = err as { message?: string };
      setError(error.message ?? 'Erro ao criar tipo de treinamento');
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleCancel = () => {
    navigate('/training-types');
  };

  return (
    <PageShell
      breadcrumbs={[
        { label: 'Início', path: '/' },
        { label: 'Tipos de Treinamento', path: '/training-types' },
        { label: 'Novo Tipo' },
      ]}
      title="Cadastrar Novo Tipo de Treinamento"
      subtitle="Preencha os dados do tipo de treinamento"
    >
      {error && (
        <Alert severity="error" sx={{ mb: 3 }} onClose={() => setError(null)}>
          {error}
        </Alert>
      )}

      <Card>
        <CardContent>
          <TrainingTypeForm
            onSubmit={handleSubmit}
            onCancel={handleCancel}
            isSubmitting={isSubmitting}
          />
        </CardContent>
      </Card>
    </PageShell>
  );
};

export default TrainingTypeCreatePage;
